import moment from 'moment';

import { HopeCollapsedEllipsis } from '@mummssoftware/utils/hope';

import defaults from '../../translations/en.json';
import { SentandAccepted, Complete } from '../HopeReviewDocument/constants';
import { formatEffectiveDate, formatEffectiveTime } from '../Context/utils';

const Unaccepted = 'Unaccepted';
const WaitingCMSAccepted = 'Waiting CMS Accepted';

const mapTitle = (title: string) =>
  title && title.includes(Unaccepted) ? WaitingCMSAccepted : title;

const hidesDueColumn = (status?: string | null) =>
  status === SentandAccepted ||
  status === Complete ||
  status === HopeCollapsedEllipsis;

export const statusMessageValueGetter = (
  eventData: mumms.HopeMilestoneEvent,
) => {
  if (!eventData?.statusmessage) return '';
  if (eventData.statusmessage === HopeCollapsedEllipsis) {
    return HopeCollapsedEllipsis;
  }
  // Backend "Complete" is the continued post-accept state — show as Sent and Accepted.
  if (eventData.statusmessage === Complete || eventData.status === Complete) {
    return SentandAccepted;
  }
  const title = mapTitle(eventData.statusmessage);
  if (
    title.toLowerCase().includes('approval') &&
    eventData.numerrors != null &&
    eventData.numerrors > 0
  ) {
    return defaults.ErrorCorrectionNeeded;
  }
  return title;
};

export const dueInMessageValueGetter = (
  eventData: mumms.HopeMilestoneEvent,
) => {
  const result =
    eventData && hidesDueColumn(eventData.status)
      ? undefined
      : eventData &&
        eventData?.possibleactions &&
        eventData?.possibleactions[0]?.due;

  return result;
};

export const EventDateTimeValueGetter = (
  eventData: mumms.HopeMilestoneEvent,
  date: boolean,
) => {
  if (
    eventData?.statusmessage === HopeCollapsedEllipsis ||
    eventData?.status === HopeCollapsedEllipsis
  ) {
    return '';
  }
  if (!date && formatEffectiveTime(eventData.effectivedate_shifted) === '01:01')
    return '';
  const value = date
    ? formatEffectiveDate(eventData.effectivedate_shifted)
    : formatEffectiveTime(eventData.effectivedate_shifted);
  return eventData?.effectivedate_shifted && eventData?.statusmessage && value;
};

export const getRowDay = (props: any) => {
  const { admissiondate_shifted, dayofservice } = props.data as mumms.HopeEvent;
  return `${dayofservice} (${moment(admissiondate_shifted)
    .add(dayofservice, 'days')
    .format('MM-DD')})`;
};

export const patientNameValueGetter = (props: any) =>
  `${props.data.firstname} ${props.data.lastname} ${
    (props.data.episodenum &&
      `(${defaults.readmit}: ${props.data.episodenum + 1})`) ||
    ''
  }`;

export const admitDayValueGetter = (props: any) => props.data.dayofservice;
